import React, { useState } from "react";
import { Btn } from "../../../../../AbstractElements";
import { Col, Label, ModalBody } from "reactstrap";
import { Form, Formik, Field } from "formik";
import * as Yup from "yup";

interface FormSubmitProp{
  modal:()=>void;
}

export const OpenModalForm = ({modal}:FormSubmitProp) => {
  const [formSubmit, setFormSubmit] = useState(false);
  const FormSchema = Yup.object().shape({
    firstname: Yup.string().min(2, "Too Short!").max(15, "Too Long!").required(),
    lastname: Yup.string().min(2, "Too Short").max(15, "Too Long").required(),
    email: Yup.string().email().required(),
  });

  return (
    <ModalBody>
      <Formik initialValues={{ firstname: "", lastname: "", email: "" }} onSubmit={modal} validationSchema={FormSchema}>
        {({ errors }) => (
          <Form className="row g-3">
            <Col md="6">
              <Label>First name</Label>
              <Field type="text" name="firstname" className={`form-control ${formSubmit && `${errors.firstname ? "is-invalid" : "is-valid"}`}`} placeholder="Enter your first-name" />
            </Col>
            <Col md="6">
              <Label>Last name</Label>
              <Field type="text" name="lastname" className={`form-control ${formSubmit && `${errors.lastname ? "is-invalid" : "is-valid"}`}`} placeholder="Enter your last-name" />
            </Col>
            <Col md="12">
              <div className="mb-3">
                <Label>Email address</Label>
                <Field type="text" name="email" className={`form-control ${formSubmit && `${errors.lastname ? "is-valid" : "is-invalid"}`}`} placeholder="Bohotheme@gmail.com" />
              </div>
            </Col>
            <Col md="12">
              <div className="form-check mb-3">
                <Field className="form-check-input" type="checkbox" name="agree" />
                <Label className="form-check-label">You accept our Terms and Privacy Policy by clicking Submit below.</Label>
              </div>
              <Btn color="primary" type="submit" onClick={() => setFormSubmit(true)}>Sign Up</Btn>
            </Col>
          </Form>
        )}
      </Formik>
    </ModalBody>
  );
};
